export const imageWidget = "LessonImageModule";
export const embedWidget = "LessonEmbedModule";
export const videoWidget = "LessonVideoModule";
export const triggerWidget = "LessonTriggerModule";
export const commentWidget = "LessonCommentModule";
export const questionWidget = "LessonQuestionModule";
export const downloadFileWidget = "LessonDownloadFileModule";
export const multipleChoiceQuestionWidget = "LessonMultipleChoiceQuestionModule";
export const fillInTheBlankWidget = "LessonFillInTheBlankModule";
